export function mapArrayToValues<Key extends string, Value>(features: Key[], mapping: Record<Key, Value[]>): Value[] {
  return features
    .map((feature) => mapping[feature])
    .flat()
    .filter(Boolean);
}
